var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'flex gap-2 items-center min-w-fit text-on-tertiary-container text-chips px-4 rounded-full transition-all duration-200 hover:transition-all hover:duration-200': true,
    'py-2 text-base': _vm.size == 'normal',
    'py-1 text-sm': _vm.size == 'small',
    'bg-inverse-on-surface': _vm.configuration == 'filled',
    'border bg-surface border-tertiary/16 hover:bg-tertiary-container/16':
      _vm.configuration == 'outlined',
    'flex-row-reverse': _vm.iconDirection == 'right',
  }},[(_vm.icon)?_c('div',{on:{"click":function($event){return _vm.$emit('click-icon')}}},[_c('Icon',{class:{
        'fill-on-tertiary-container': true,
        'max-h-6 max-w-6 w-6 h-6': _vm.size == 'normal',
        'max-h-[18px] max-w-[18px] w-[18px] h-[18px]': _vm.size == 'small',
        'cursor-pointer': _vm.iconIsAction,
      },attrs:{"name":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }